export enum ServiceCustomerStatus {
  PROPOSED = "Non avviato",
  ACTIVE = "Attivo",
  ARCHIVED = "Archiviato",
  CANCELED = "Annullato",
}

export enum DeleteReportType {
  ALL = "CancellazioneSegnalazioni",
  DELETEREPORTALL = "CancellazioneSegnalazioniSic&CancellazioneSegnalazioniProtesti",
  DELETESIC = "CancellazioneSegnalazioniSic",
  DELETEPROP = "CancellazioneSegnalazioniProtesti",
}

export interface ServiceCustomer {
  _id: string;
  fee: number;
  arrayTranche: any[];
  tranche: any;
  bank: string;
  nContract: string;
  contractType: string;
  customerId: string;
  serviceId: string;
  subTitle: string;
  status: "PROPOSED" | "ACTIVE" | "ARCHIVED" | "CANCELED";
  serviceStatus?: { status: string, expireAt: string | null }
  broker: string;
  relatives?: ServiceCustomerRelative[];
}

export interface ServiceCustomerRelative {
  _id: string;
  relativeId: string;
  relation: string;
}

export interface ServiceCustomerRelativeInfo {
  _id: string;
  first_name: string;
  last_name: string;
  cf: string;
}
